import React, { Component } from 'react'
import { SearchBarTable } from 'hljd'
import { observer, inject } from 'mobx-react'
import getColumns from './columns'
import SetVerticalModal from '@common/SetVerticalImgModal'

@inject('store')
@observer
export default class extends Component {
  render() {
    const { store } = this.props
    return (
      <>
        <SearchBarTable
          columns={getColumns(store)}
          store={store}
          style={{ marginTop: 20 }}
        />
        <SetVerticalModal
          superImage={store.vertical_image}
          title="选取宴会厅横图"
          visible={store.verticalImgVisible}
          onOk={store.saveVerticalImgModal}
          onCancel={store.closeVerticalImgModal}
          onCliped={store.verticalImgModalonCliped}
          onDelte={store.verticalImgModalonDelete}
          uploadConfig={{
            aspect: 540 / 540
          }}
          clipModalConfig={{
            aspect: 540 / 540
          }}
        />
      </>
    )
  }
}
